import React from 'react';
import {APP_VERSION, APP_YEAR} from "../../constants/appConstants";

import {Navbar, Nav, NavItem} from 'reactstrap';

const Footer = () => {
    return (
        <Navbar className='sticky-bottom text-center'>
            <Nav navbar className='bottom-nav'>
                <NavItem>
                    {APP_YEAR} {process.env.REACT_APP_NAME}
                </NavItem>
                <NavItem className='app-version'>
                    {APP_VERSION}
                </NavItem>
            </Nav>
        </Navbar>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.js